import * as React from "react";
import { ResponsiveBar } from "@nivo/bar";
import graphData from "../../assets/data/samplebargraphdata";

const colors = {
  'Severe Alert': '#e7233d',
  'High Alert': '#8e0666',
  'Moderate Alert': '#f56f3f',
  'Low Alert': '#feb743',
  'No Alert': '#18ee97'
}


export default class StackedBarGraph extends React.Component {
  state = {};
  constructor(props) {
    super(props);
  }
  
  render() {
    return (
      <div style={{ width: "100%", height: "500px" }} className="nivocontainer">
        <ResponsiveBar
          data={this.props.data}
          keys={["No Alert", "Low Alert", "Moderate Alert", "High Alert", "Severe Alert"]}
          indexBy="assessment"
          margin={{ top: 30, right: 70, bottom: 70, left: 70 }}
          padding={0.3}
          groupMode="grouped"
          colors={ bar => colors[bar.id]}
          theme={{

            axis: {
              fontSize: "14px",
              tickColor: "#eee",
              ticks: {
                line: {
                  stroke: "#e7233d"
                },
                text: {
                  fill: "#ffffff"
                }
              },
              legend: {
                text: {
                  fill: "#aaaaaa",
                  fontFamily: "Roboto Condensed",
                  fontWeight: 'bold',
                  fontSize: '16px'
                }
              }
            },
            grid: {
              line: {
                stroke: "#999"
              }
            }
          }}

          borderColor={ "#fff" }
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Assessment",
            legendPosition: "middle",
            legendOffset: 32
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: `% of ${this.props.userType}`,
            legendPosition: "middle",
            legendOffset: -40
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={"#1a1a1a"}
          legends={[
            {
            itemTextColor: "#fff",
              dataFrom: "keys",
              anchor: "bottom",
              direction: "row",
              justify: false,
            //   translateX: 120,
              translateY: 80,
              itemsSpacing: 5,
              itemWidth: 100,
              itemHeight: 30,
              itemDirection: "left-to-right",
              itemOpacity: 0.85,
              symbolSize: 15,
              effects: [
                {
                  on: "hover",
                  style: {
                    itemOpacity: 1
                  }
                }
              ]
            }
          ]}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/DataViz/stackedBarGraph.Component.js